var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhenotypic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1736239839854,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 23127,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M373.333333 149.333333c0-41.216 33.408-74.666667 74.666667-74.666666h426.666667c41.216 0 74.666667 33.450667 74.666666 74.666666v426.666667a74.666667 74.666667 0 0 1-74.666666 74.666667h-224v224a74.666667 74.666667 0 0 1-74.666667 74.666666h-426.666667a74.666667 74.666667 0 0 1-74.666666-74.666666v-426.666667c0-41.258667 33.450667-74.666667 74.666666-74.666667h224V149.333333z m74.666667-10.666666a10.666667 10.666667 0 0 0-10.666667 10.666666v256a32 32 0 0 1-32 32h-256a10.666667 10.666667 0 0 0-10.666666 10.666667v426.666667c0 5.888 4.778667 10.666667 10.666666 10.666666h426.666667a10.666667 10.666667 0 0 0 10.666667-10.666666v-256a32 32 0 0 1 32-32h256a10.666667 10.666667 0 0 0 10.666666-10.666667v-426.666667a10.666667 10.666667 0 0 0-10.666666-10.666666h-426.666667z",
    "p-id": 23128,
    fill: "#46766a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhenotypic);
export default __webpack_public_path__ + "static/media/Phenotypic.d91d905dcc1445c03893259e0a58ad41.svg";
export { ForwardRef as ReactComponent };